import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/courseProgress/importer/courseProgressImporterActions'

export default importerReducers(actions)
